export default __webpack_public_path__ + "static/media/img6.022d71d9.png";